export default __webpack_public_path__ + "static/media/snake.ad6380d1.png";